<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-data-table :headers="headers" :items="graphs" hide-actions no-data-text="Статистики отсутствуют">
        <template slot="items" slot-scope="{item, index}">
          <td>{{item.name}}</td>
          <td v-html="getLinesNames(item.lines)"></td>
          <td class="text-xs-center pa-0 ma-0" v-if="editable">
            <v-btn color="error" class="ma-0" icon flat @click="deleteGraph(index)"><v-icon>mdi-delete</v-icon></v-btn>
          </td>
        </template>
      </v-data-table>
      <span v-if="editable" class="dashed pointer pull-right my-2" @click="showPanel=!showPanel">{{showPanel?'Свернуть панель':'Добавить линию'}}</span>
    </v-flex>
    <template v-if="editable">
      <v-flex xs12 md5 v-show="showPanel">
        <p class="body-2">Статистики</p>
        <v-treeview :items="available_statistics" class="densed pb-1" item-key="key" :active="treeactive">
          <template slot="prepend" slot-scope="{ item, open, leaf }">
            <v-icon size="20" class="mx-0" @contextmenu="openMenu($event, item, 'shared')">{{item.icon}}</v-icon>
          </template>
          <label slot="label" class="pointer" slot-scope="{item}" @click="getLines(item)">{{item.name}}</label>
        </v-treeview>
      </v-flex>
      <v-flex xs12 md7 v-show="showPanel">
        <p class="body-2">Линии</p>
        <template v-if="selectedStatistic">
          <div class="text-xs-center" v-if="loading">
            <p>Загрузка ...</p>
            <v-progress-circular :size="50" :width="5" indeterminate color="primary"></v-progress-circular>
          </div>
          <template v-else>
            <v-treeview :items="lines" v-model="tree" class="densed pb-1" return-object selectable v-if="lines.length>0">
              <template slot="prepend" slot-scope="{ item, open, leaf }">
                <v-icon size="20" class="mx-0" @contextmenu="openMenu($event, item, 'shared')">{{item.icon}}</v-icon>
              </template>
              <label slot="label" class="pointer" slot-scope="{item}" v-html="item.name"></label>
            </v-treeview>
            <p v-else>Линии отсутствуют</p>
            <v-btn small color="secondary" v-if="lines.length>0" @click="addGraph">Добавить</v-btn>
          </template>
          
        </template>
        <template v-else>
          <span class="body-1">Выберите статистику</span>
        </template>
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
  import entities from '@/mixins/entities'
  import {mapState} from 'vuex'
  
  export default {
    name : "StatisticSelect",
  
    mixins: [entities],
    
    props: {
      value : {
        type : Array,
        required : false,
        default : () => []
      },
      editable: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    
    created(){
      if(this.editable){
        this.headers.push({ text: 'Действия', align: 'center', sortable: false, width: 100 })
      }
    },
    
    computed:{
      ...mapState(`analytics/statistics`, ['my_statistics', 'shared_statistics']),
      graphs:{
        get(){ return this.value },
        set(v){ }
      },
      available_statistics(){
        return [
          {id: 'my_statistics', name: 'Мои статистики', children: this.my_statistics},
          {id: 'shared_statistics', name: 'Доступные статистики', children: this.shared_statistics}
        ]
      }
    },
    
    data(){
      return {
        treeactive: [],
        tree: [],
        headers: [
          { text: 'Статистика', align: 'left', sortable: false },
          { text: 'Линии', align: 'left', sortable: false },
        ],
        showPanel: false,
        lines: [],
        selectedStatistic: null,
        loading: false
      }
    },
    
    methods:{
      getLinesNames(lines){
        let result = ''
        lines.map( (line, index) => {
          result+=`<b>${index+1}</b>. ${line.name}<br>`
        })
        return result
      },
  
      getLines(item){
        if(item.element_type==='graph'){
          this.loading = true
          this.selectedStatistic = item
          this.treeactive = [item.key]
          this.$store.dispatch('analytics/statistics/getGraph', item.id).then( response => {
            this.lines = response.lines
            this.convertOutputSettings(this.lines)
          }).finally( _ => {
            this.loading = false
          })
        }
      },
      
      addGraph(){
        this.graphs.push({
          graph_id: this.selectedStatistic.id,
          name: this.selectedStatistic.name,
          lines: this.tree
        })
        this.tree = []
        this.selectedStatistic = null
        this.treeactive = []
        this.lines = []
        this.$emit('input', this.graphs)
      },
      
      deleteGraph(index){
        this.graphs.splice(index, 1)
        this.$emit('input', this.graphs)
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Common/StatisticSelect.vue